import React from 'react';
import { companyInfo } from '../data/mock';
import { Phone, Mail, MapPin, Sun, ArrowRight } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const navItems = [
    { label: 'Leistungen', href: '#leistungen' },
    { label: 'Referenzen', href: '#referenzen' },
    { label: 'Über uns', href: '#ueber-uns' },
    { label: 'Rechner', href: '#autarkie-rechner' },
    { label: 'Ablauf', href: '#ablauf' },
    { label: 'FAQ', href: '#faq' },
    { label: 'Kontakt', href: '#kontakt' }
  ];

  return (
    <footer className="bg-slate-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Logo & Description */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-sun-orange rounded-xl flex items-center justify-center">
                <Sun className="w-7 h-7 text-white" />
              </div>
              <span className="font-bold text-2xl">Sunprojects</span>
            </div>
            <p className="text-slate-400 leading-relaxed mb-6">
              Ihr regionaler Partner für Photovoltaik, Speicher und Wärmepumpen. 
              Seit über 20 Jahren planen und installieren wir Energiesysteme für Ihr Zuhause.
            </p>
            <a 
              href="#kontakt" 
              className="inline-flex items-center text-sun-orange font-semibold hover:underline group"
            >
              Kostenlose Beratung
              <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
            </a>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-semibold text-lg mb-6">Navigation</h4>
            <ul className="space-y-3">
              {navItems.map((item) => (
                <li key={item.label}>
                  <a 
                    href={item.href} 
                    className="text-slate-400 hover:text-sun-orange transition-colors"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Standort */}
          <div>
            <h4 className="font-semibold text-lg mb-6">Standort</h4>
            <div className="space-y-6">
              <div>
                <p className="font-medium text-white mb-2">{companyInfo.contact.address.label}</p>
                <p className="text-slate-400 text-sm leading-relaxed">
                  {companyInfo.name}<br />
                  {companyInfo.contact.address.street}<br />
                  {companyInfo.contact.address.zip} {companyInfo.contact.address.city}
                </p>
              </div>
            </div>
          </div>

          {/* Kontakt */}
          <div>
            <h4 className="font-semibold text-lg mb-6">Kontakt</h4>
            <div className="space-y-4">
              <div className="mb-4">
                <p className="font-medium text-white">{companyInfo.contact.person}</p>
                <p className="text-slate-500 text-sm">{companyInfo.contact.position}</p>
              </div>
              <a 
                href={`tel:${companyInfo.contact.phone}`} 
                className="flex items-center gap-3 text-slate-400 hover:text-sun-orange transition-colors group"
              >
                <div className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center group-hover:bg-sun-orange/20 transition-colors">
                  <Phone className="w-5 h-5" />
                </div>
                {companyInfo.contact.phone}
              </a>
              <a 
                href={`mailto:${companyInfo.contact.email}`} 
                className="flex items-center gap-3 text-slate-400 hover:text-sun-orange transition-colors group"
              >
                <div className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center group-hover:bg-sun-orange/20 transition-colors">
                  <Mail className="w-5 h-5" />
                </div>
                {companyInfo.contact.email}
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-sm">
              © {currentYear} {companyInfo.name}. Alle Rechte vorbehalten.
            </p>
            <div className="flex items-center gap-6">
              <a 
                href="/impressum" 
                className="text-slate-500 hover:text-sun-orange text-sm transition-colors"
              >
                Impressum
              </a>
              <a 
                href="/datenschutz" 
                className="text-slate-500 hover:text-sun-orange text-sm transition-colors"
              >
                Datenschutz
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
